import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  CreateSupportTemplateRequest,
  UpdateSupportTemplateRequest,
  ViewSupportTemplateRequest
} from './support-template.types';

export const requestCreateSupportTemplate = createAction<SagaPayload<CreateSupportTemplateRequest>['payload']>(
  'request/createSupportTemplate'
);

export const requestViewSupportTemplate =
  createAction<SagaPayload<ViewSupportTemplateRequest>['payload']>('request/ViewSupportTemplate');

export const requestUpdateSupportTemplate = createAction<SagaPayload<UpdateSupportTemplateRequest>['payload']>(
  'request/UpdateSupportTemplate'
);
